import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react'
import Navbar from './Navbar/Navbar';
import Footer from './Footer';
import School_begins_enrollment from './School_begins_enrollment';
import { updateProductCount } from '../redux/fetcher/TarrotCardSlice';
import { useDispatch } from 'react-redux';
import Footer2 from './Footer2';

const Layout = ({ children }) => {
    console.log("children --------->", children);
    const router = useRouter();
    const dispatch = useDispatch()
    console.log("router+++", router);

    useEffect(() => {
        let count = localStorage.getItem('cartCount')
        dispatch(updateProductCount(parseInt(count)))
    }, [router])

    return (
        <>
            {
                (router.pathname != '/login'
                    && router.pathname != '/tarot-reader-signup'
                    && router.pathname != '/tarot-astro-signup'
                    // &&router.pathname != '/purchase'
                    && router.pathname != '/subscription'
                    && router.pathname != '/astrologer-signup'
                    && router.pathname != '/customer-signup'
                    && router.pathname != '/trainee-signup'
                    && router.pathname != '/termsandconditions'
                    && router.pathname != '/payment-success-page'
                    && router.pathname != '/event-subscription'
                    && router.pathname != '/manage-subscriptions'
                    && router.pathname != '/DaNang'
                    && router.pathname != '/DaNang-2'
                    && router.pathname != '/Da-Nang'
                    && router.pathname != '/KoiFishCafe'
                    && router.pathname != '/KoiFish-Cafe'
                    // && router.pathname != '/diviner-signup/653107e2f5faed5aab8b9a24'
                    // && router.pathname != `trainee-purchase/653107e2f5faed5aab8b9a24`
                    // || (router.pathname.includes("payment-successful") || router.pathname.includes("thankyou"))
                )
                &&
                <School_begins_enrollment />
            }

            {
                (router.pathname != '/payment-success-page') &&
                (router.pathname != '/login' && router.pathname != '/subscription' && router.pathname != '/event-subscription' && router.pathname != '/manage-subscriptions')
                && <Navbar />
            }

            <main>
                {children}
            </main>
            {
                (router.pathname != '/login' && router.pathname != '/subscription' && router.pathname != '/payment-success-page' && router.pathname != '/event-subscription' && router.pathname != '/manage-subscriptions')

                // && <Footer />
                && <Footer2 />
            }
        </>
    )
}

export default Layout